import axios from 'axios'
import { genProcess } from './utils'

const BASIC_METHODS = [
  'get',
  'put',
  'post',
  'head',
  'patch',
  'delete',
]

export class PipeHttp {
  constructor (http = axios) {
    const that = this
    const resData = new Map()
    this.processes = []
    BASIC_METHODS.forEach(method => {
      this[method] = (url, ...args) => run({ method, url, args })
    })
    const run = async ({ method, index = 0, key = Symbol('run'), url, args } = {}) => {
      const fn = that.processes[index]
      try {
        if (typeof fn !== 'function') {
          const data = await http[method](url, ...args)
          resData.set(key, { data: data })
        } else {
          await fn({ method, args, url }, () => run({ method, index: index + 1, key, url, args }))
        }
      } catch (error) {
        resData.set(key, { error })
      }
      if (index === 0) {
        const { data, error } = resData.get(key)
        resData.delete(key)
        return error ? Promise.reject(error) : Promise.resolve(data)
      }
    }
  }
  pipe (processes = []) {
    this.processes.push(...processes)
    return this
  }
  genProcess (callback) {
    const fn = genProcess(callback)
    const that = this
    return (metaData) => {
      that.pipe([fn(metaData)])
      return that
    }
  }
}
